/* RoyalMouthguard 2D/3D Designer v1.9 – side-by-side 2D editor and expandable lazy WebGL preview.
 * Original custom mouthguard UV mask + fixed inner gold, black/white shell.
 */
(() => {
  'use strict';
  const WIDTH = 960, HEIGHT = 420, MAX_IMAGES = 6, MAX_IMAGE_BYTES = 4 * 1024 * 1024;
  const FONTS = ['Arial', 'Impact', 'Georgia', 'Trebuchet MS', 'Courier New'];
  const COLORS = ['#111827', '#FFFFFF', '#C62828', '#D4AF37', '#1554D1'];
  const LANG_TEXT_RM={"de":{"subtitle":"Gestalte deinen Mundschutz mit Text und eigenen Bildern. Dein Design siehst du gleichzeitig in 2D und am 3D-Modell.","base_color":"Mundschutz-Farbe","white":"Weiß","black":"Schwarz","white_aria":"Weißer Mundschutz","black_aria":"Schwarzer Mundschutz","design_text":"Text gestalten","text_limit":"Text (max. 150 Zeichen)","font":"Schriftart","font_size":"Schriftgröße","text_color":"Textfarbe","text_placeholder":"z. B. MA​​KIN","add_text":"Text hinzufügen","own_image_title":"Eigenes Bild hinzufügen","select_image":"Bild vom Gerät auswählen","upload_hint":"PNG, JPG oder WebP • max. 4 MB je Bild • bis zu 6 Bilder. Für Logos empfehlen wir PNG mit transparentem Hintergrund.","canvas_title":"Deine 2D-Druckfläche","canvas_hint":"Elemente verschieben · mit den Eckgriffen skalieren","original_outline":"Originalkontur","canvas_aria":"Interaktive Designfläche","edit_tools":"Elemente bearbeiten","center":"Zentrieren","bring_front":"Nach vorne","send_back":"Nach hinten","undo":"Rückgängig","redo":"Wiederholen","delete":"Löschen","edit_hint":"Verschieben: ziehen. Größe: blaue Eckpunkte. Drehen: runder Griff. Pfeiltasten: fein verschieben.","layers_title":"Deine Ebenen","preview_title":"3D-Live-Vorschau","model_preparing":"3D-Vorschau wird vorbereitet …","model_hint":"Ziehen: drehen · Scrollen: zoomen · Innen Goldmetallic","model_aria":"Drehbarer 3D-Mundschutz","expand_aria":"3D-Vorschau vergrößern","collapse_aria":"Große 3D-Vorschau schließen","expand":"Vergrößern","close":"Schließen","cart_button":"Design in den Warenkorb","files_preparing":"Dateien werden vorbereitet …","missing_product":"Bitte im Theme-Editor ein Produkt für diesen Konfigurator auswählen.","missing_product_button":"Produkt fehlt","export_summary":"Optional: Projekt speichern oder Design exportieren","export_png":"Design als PNG","export_json":"Projekt speichern","import_json":"Projekt laden","export_hint":"Bei einer Bestellung werden deine Designdateien automatisch mitgesendet. Hier kannst du sie optional selbst sichern.","footnote":"Hinweis: Die Vorschau dient zur Orientierung. Druckplatzierung und technische Machbarkeit werden vor der Fertigung geprüft.","selected_none":"Kein Element ausgewählt","selected_text":"Text ausgewählt","selected_image":"Bild ausgewählt","empty_layers":"Noch kein Text oder Bild hinzugefügt.","own_image":"Eigenes Bild","model_loading":"3D-Modell wird geladen …","model_unavailable":"Die 3D-Vorschau steht auf diesem Gerät nicht zur Verfügung. Du kannst weiter in 2D gestalten.","model_failure_prefix":"3D konnte nicht geladen werden: ","model_failure_suffix":" Das Gestalten in 2D funktioniert weiterhin.","reset_confirm":"Alle Elemente aus dem Entwurf entfernen?","bg_remove":"Hintergrund entfernen","bg_restore":"Original wiederherstellen","bg_sensitivity":"Empfindlichkeit","bg_hint":"Für möglichst einfarbige Bildhintergründe. Das Original bleibt erhalten."},"en":{"subtitle":"Customize your mouthguard with text and images. See your design in 2D and on the 3D model at the same time.","base_color":"Mouthguard color","white":"White","black":"Black","white_aria":"White mouthguard","black_aria":"Black mouthguard","design_text":"Add text","text_limit":"Text (max. 150 characters)","font":"Font","font_size":"Font size","text_color":"Text color","text_placeholder":"e.g. YOUR NAME","add_text":"Add text","own_image_title":"Upload your image","select_image":"Choose an image","upload_hint":"PNG, JPG or WebP • up to 4 MB per image • maximum 6 images. Transparent PNG recommended for logos.","canvas_title":"Your 2D design","canvas_hint":"Drag to move · use corner handles to resize","original_outline":"Original outline","canvas_aria":"Interactive design canvas","edit_tools":"Edit elements","center":"Center","bring_front":"Bring forward","send_back":"Send backward","undo":"Undo","redo":"Redo","delete":"Delete","edit_hint":"Drag to move. Resize with the blue corners, rotate using the round handle, or use arrow keys for fine adjustments.","layers_title":"Your layers","preview_title":"3D live preview","model_preparing":"Preparing 3D preview …","model_hint":"Drag to rotate · Scroll to zoom · Metallic gold interior","model_aria":"Rotatable 3D mouthguard","expand_aria":"Expand 3D preview","collapse_aria":"Close enlarged 3D preview","expand":"Expand","close":"Close","cart_button":"Add design to cart","files_preparing":"Preparing files …","missing_product":"Select a product for this designer in the theme editor.","missing_product_button":"Product unavailable","export_summary":"Optional: save your project or export the design","export_png":"Design as PNG","export_json":"Save project","import_json":"Load project","export_hint":"Your design files are attached automatically when you order. You can also save them here for later.","footnote":"The preview is for guidance. Print placement and production feasibility will be checked before manufacturing.","selected_none":"No element selected","selected_text":"Text selected","selected_image":"Image selected","empty_layers":"No text or images added yet.","own_image":"Your image","model_loading":"Loading 3D model …","model_unavailable":"3D preview isn't available on this device. You can still design in 2D.","model_failure_prefix":"Could not load 3D model: ","model_failure_suffix":" You can still design in 2D.","reset_confirm":"Remove all elements from your design?","bg_remove":"Remove background","bg_restore":"Restore original","bg_sensitivity":"Sensitivity","bg_hint":"Best for images with plain backgrounds. Your original image is kept."}};
  const STATUS_EN_RM={"Ein Bild konnte nicht geladen werden.":"An image could not be loaded.","3D-Vorschau konnte nicht geladen werden.":"The 3D preview could not be loaded.","Text hinzugefügt. Zum Verschieben einfach ziehen.":"Text added. Drag to move it.","Transparentes Produktions-PNG gespeichert.":"Transparent production PNG saved.","Editierbare Projektdatei gespeichert.":"Editable project file saved.","Bitte PNG, JPG oder WebP hochladen.":"Please upload a PNG, JPG or WebP image.","Bitte Bilder bis 4 MB auswählen.":"Please choose images up to 4 MB.","Maximal sechs eigene Bilder pro Design.":"You can upload up to six images per design.","Bilder zusammen dürfen maximal 9 MB groß sein.":"All uploaded images must total no more than 9 MB.","Bild konnte nicht gelesen werden.":"The image could not be read.","Bildformat nicht unterstützt.":"Unsupported image format.","Bild hinzugefügt. An den Eckpunkten skalieren.":"Image added. Resize using the corner handles.","Bild ist beschädigt oder nicht lesbar.":"The image is damaged or unreadable.","Projektdatei zu groß (maximal 16 MB).":"Project file is too large (max. 16 MB).","Projekt erfolgreich geladen.":"Project loaded successfully.","Bitte füge zuerst Text oder ein Bild hinzu.":"Please add text or an image first.","Ein Bild lädt noch oder konnte nicht geladen werden.":"An image is still loading or could not be loaded.","Demo-Modus: Hier kannst du die Dateien exportieren. Im Shopify-Theme funktioniert danach der echte Warenkorb.":"Demo mode: You can export the design files here. The Shopify store supports checkout.","Bitte eine verfügbare Produktvariante auswählen.":"Please select an available product variant.","Dateien vorbereitet. Weiterleitung zum Warenkorb …":"Files prepared. Opening your cart …","PNG konnte nicht an den Warenkorb übertragen werden.":"The PNG file could not be attached to the cart.","UV-Hilfsbild konnte nicht angezeigt werden – Standardvorlage aktiv.":"The UV guide could not be displayed. Using the default template.","Ungültige Projektdatei.":"Invalid project file.","PNG konnte nicht erstellt werden.":"The PNG file could not be created.","Bitte zuerst ein Bild auswählen.":"Please select an image first.","Bild wird freigestellt …":"Removing background …","Hintergrund entfernt. Das Original bleibt erhalten.":"Background removed. The original is preserved.","Originalbild wiederhergestellt.":"Original image restored.","Hintergrund konnte nicht eindeutig erkannt werden. Verwende ein Bild mit möglichst einfarbigem Hintergrund.":"Could not identify a clear background. Try an image with a plain background.","Das Bild ist bereits transparent.":"The image already has a transparent background.","Der Hintergrund ließ sich nicht sicher entfernen. Passe die Empfindlichkeit an.":"The background could not be removed reliably. Try adjusting the sensitivity.","Das Bild ist zu groß für die Bearbeitung auf diesem Gerät.":"This image is too large to process on this device.","Die Bildfreistellung ist fehlgeschlagen. Das Original bleibt unverändert.":"Background removal failed. The original image was not changed.","Bitte warten, bis das Bild bearbeitet wurde.":"Please wait until image processing has finished.","Cricut-Produktions-PNG mit Mundschutzfarbe gespeichert.":"Cricut production PNG with the selected mouthguard colour saved."};
  function translateStatusRM(lang, message) {
    if(lang!=='en')return message;
    if(Object.prototype.hasOwnProperty.call(STATUS_EN_RM,message))return STATUS_EN_RM[message];
    const prefixes=[["Projekt konnte nicht importiert werden: ","Could not import project: "],["Bestellung nicht gestartet: ","Could not start checkout: "]];
    for(const [de,en] of prefixes)if(message.startsWith(de))return en+message.slice(de.length);
    return message;
  }
  const $ = (root, name) => root.querySelector(`[data-role="${name}"]`);
  const num = (v, d) => Number.isFinite(Number(v)) ? Number(v) : d;
  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
  const id = () => 'r' + Math.random().toString(36).slice(2, 10);

  // Original SVG / viewBox 0 0 366.14 57.63 (Royalmouthguard 3-Laender-Vorlage).
  // The path is embedded so it remains available even when Shopify asset paths change.
  const SVG_PRINT_W = 366.14, SVG_PRINT_H = 57.63;
  const PRINT_ZONE = {x:46, y:141, w:868, h:868 * SVG_PRINT_H / SVG_PRINT_W};
  const SVG_PRINT_PATH = new Path2D("M136.5.57c19.41-.29,34.09,1.74,46.56,7.92C194.88,2.85,214.33-.84,232.9.16c7.85.42,15.55,2.29,22.81,5.31l.32.13c5.29,2.1,11.12,3.49,17.28,4.56,3.63.63,6.96-.08,9.95-.97,3.68-1.1,7.43-1.94,11.24-2.44,2.86-.38,5.71-.76,8.57-1.14,19.19-3.19,49.2,3.91,56.4,13.2,3.5,4.52,4.7,9.93,6,16.8.6,3.16,1.05,7.79.24,11.04-5.04,3.67-17.87-.14-25.68-.24-21.62-.27-44.67-1.6-65.04,1.68-6,.56-12,1.12-18,1.68-18.21,3.19-35.63,4.54-54.05,7.26-2.84.42-5.71.63-8.59.59-3.68-.06-7.36-.12-11.04-.17-18.95-.15-34.5-1.51-50.4-4.56-17.62-3.38-36.16-2.8-54.72-5.76-8.64-.32-17.28-.64-25.92-.96-7.65-1.19-20.98-.95-28.56.24-6.36,1-16.36,2.8-22.08,1.44-1.84-2.51-1.92-6.56-1.2-10.56,2.44-13.63,5.14-19.92,16.32-24.72,12.14-5.21,30.33-9.72,48.96-6.72,3.92.56,7.84,1.12,11.76,1.68,4.23,1.06,9.33,3.65,15.36,2.64,5.62-.95,10.45-2.64,15.08-4.38,6.1-2.3,12.47-3.79,18.96-4.36,3.21-.28,6.43-.57,9.64-.85Z");
  function withinPrintZone(ctx, fn) {
    ctx.save();
    ctx.translate(PRINT_ZONE.x, PRINT_ZONE.y);
    ctx.scale(PRINT_ZONE.w / SVG_PRINT_W, PRINT_ZONE.h / SVG_PRINT_H);
    fn(ctx, SVG_PRINT_PATH);
    ctx.restore();
  }
  function clipPrintZone(ctx) {
    const sx = PRINT_ZONE.w / SVG_PRINT_W, sy = PRINT_ZONE.h / SVG_PRINT_H;
    ctx.translate(PRINT_ZONE.x, PRINT_ZONE.y);
    ctx.scale(sx, sy);
    ctx.clip(SVG_PRINT_PATH);
    // Undo the transform but keep the geometric clip region in place.
    ctx.scale(1 / sx, 1 / sy);
    ctx.translate(-PRINT_ZONE.x, -PRINT_ZONE.y);
  }
  function roundRect(ctx, x,y,w,h,r) {
    r = Math.min(r,w/2,h/2);
    ctx.beginPath();ctx.moveTo(x+r,y);ctx.arcTo(x+w,y,x+w,y+h,r);ctx.arcTo(x+w,y+h,x,y+h,r);
    ctx.arcTo(x,y+h,x,y,r);ctx.arcTo(x,y,x+w,y,r);ctx.closePath();
  }
  function pointInObject(p, o) {
    const a = -(o.angle || 0), dx = p.x-o.x, dy=p.y-o.y;
    const rx = dx*Math.cos(a)-dy*Math.sin(a), ry=dx*Math.sin(a)+dy*Math.cos(a);
    return Math.abs(rx)<=o.w/2 && Math.abs(ry)<=o.h/2;
  }
  function transformed(o, dx, dy) {
    const a = o.angle || 0;
    return {x:o.x+dx*Math.cos(a)-dy*Math.sin(a), y:o.y+dx*Math.sin(a)+dy*Math.cos(a)};
  }
  function textMetrics(o) {
    const s = clamp(num(o.scale,1), 0.15, 9);
    const measure = document.createElement('canvas').getContext('2d');
    measure.font = `900 ${num(o.fontSize, 58)}px "${o.font || 'Arial'}"`;
    const lines = String(o.text||'DEIN TEXT').split('\n').slice(0,3);
    const widest = Math.max(20, ...lines.map(t=>measure.measureText(t).width));
    return {w:widest*s+14, h:lines.length * num(o.fontSize,58)*1.12*s+8};
  }
  function serializeObjects(items) {
    return items.map(item => {
      const copy={...item};delete copy.img;delete copy.loading;
      return copy;
    });
  }
  function safeImageSource(src) {
    return typeof src === 'string' && /^data:image\/(png|jpeg|webp);base64,[A-Za-z0-9+/=]+$/.test(src);
  }


  // v2.4: local, no-dependency, optional flood-fill cutout.
  // This detects background colours connected to the image edges; it is not AI object recognition.
  function removeConnectedBackgroundRM(image, tolerance) {
    const iw=image.naturalWidth, ih=image.naturalHeight;
    if(!iw||!ih)throw new Error('invalid image');
    // Bound the working bitmap for mobile memory, keeping the original untouched for undo/retry.
    const scale=Math.min(1,2500/Math.max(iw,ih),Math.sqrt(2600000/(iw*ih)));
    const w=Math.max(1,Math.floor(iw*scale)), h=Math.max(1,Math.floor(ih*scale));
    const n=w*h;
    const canvas=document.createElement('canvas');
    canvas.width=w;canvas.height=h;
    const ctx=canvas.getContext('2d',{willReadFrequently:true});
    if(!ctx)throw new Error('no canvas context');
    ctx.drawImage(image,0,0,w,h);
    const frame=ctx.getImageData(0,0,w,h),pixels=frame.data;
    const refs=[];
    const margin=Math.max(0,Math.min(3,Math.floor(Math.min(w,h)/60)));
    for(const [u,v] of [[0,0],[0.5,0],[1,0],[0,0.5],[1,0.5],[0,1],[0.5,1],[1,1]]){
      const x=Math.max(0,Math.min(w-1,Math.round(u*(w-1))+(u===0?margin:(u===1?-margin:0))));
      const y=Math.max(0,Math.min(h-1,Math.round(v*(h-1))+(v===0?margin:(v===1?-margin:0))));
      const p=(y*w+x)*4;
      refs.push([pixels[p],pixels[p+1],pixels[p+2],pixels[p+3]]);
    }
    const alreadyTransparent=refs.filter(x=>x[3]<32).length>=5;
    if(alreadyTransparent)return {alreadyTransparent:true};
    let group=null;
    // Prefer a background colour appearing on at least three independent border samples.
    for(const color of refs){
      if(color[3]<64)continue;
      const similar=refs.filter(c=>c[3]>64 &&
        Math.abs(c[0]-color[0])<48 && Math.abs(c[1]-color[1])<48 && Math.abs(c[2]-color[2])<48);
      if(!group||similar.length>group.length)group=similar;
    }
    if(!group||group.length<3)return {ambiguous:true};
    const bg=[
      group.reduce((a,c)=>a+c[0],0)/group.length,
      group.reduce((a,c)=>a+c[1],0)/group.length,
      group.reduce((a,c)=>a+c[2],0)/group.length
    ];
    const tol=Math.max(30,Math.min(150,Number(tolerance)||70));
    const tolSquared=3*tol*tol;
    const visited=new Uint8Array(n),queue=new Int32Array(n);
    let head=0,tail=0;
    function tryPush(index){
      if(visited[index])return;
      const p=index*4;
      const dr=pixels[p]-bg[0],dg=pixels[p+1]-bg[1],db=pixels[p+2]-bg[2];
      if(pixels[p+3]<16 || dr*dr+dg*dg+db*db<=tolSquared){
        visited[index]=1;
        queue[tail++]=index;
      }
    }
    for(let x=0;x<w;x++){tryPush(x);tryPush((h-1)*w+x);}
    for(let y=1;y<h-1;y++){tryPush(y*w);tryPush(y*w+w-1);}
    while(head<tail){
      const pos=queue[head++],x=pos%w;
      if(x>0)tryPush(pos-1);
      if(x+1<w)tryPush(pos+1);
      if(pos>=w)tryPush(pos-w);
      if(pos+w<n)tryPush(pos+w);
    }
    // Avoid destroying the whole image when no clear subject remains.
    if(tail<n*0.015 || tail>n*0.985)return {ambiguous:true};
    for(let i=0;i<tail;i++)pixels[queue[i]*4+3]=0;
    ctx.putImageData(frame,0,0);
    const result=canvas.toDataURL('image/png');
    if(result.length>14*1024*1024)return {tooLarge:true};
    return {src:result,wasDownscaled:scale<0.999,removedFraction:tail/n};
  }

  function initialize(root) {
    if (root.dataset.ready === '1') return;
    root.dataset.ready = '1';
    const editCanvas = $(root,'editor');
    if (!editCanvas) return;
    const edit = editCanvas.getContext('2d');
    const textField=$(root,'text-value'), fontField=$(root,'font'), fontSizeField=$(root,'font-size');
    const colorField=$(root,'text-color'), baseField=$(root,'base-color'), imageInput=$(root,'image-file');
    const status=$(root,'status'), layers=$(root,'layers'), addButton=$(root,'add-to-cart');
    const bgTools=$(root,'bg-tools'), bgRemove=$(root,'bg-remove'), bgRestore=$(root,'bg-restore'), bgTolerance=$(root,'bg-tolerance');
    let bgBusy=false;
    const BASES = ['#FFFFFF', '#111111'];
    const state = {items:[],selected:null,base:'#FFFFFF', guide:null,
      history:[],historyAt:-1,gesture:null,busy:false};
    const modelTexture=document.createElement('canvas');
    modelTexture.width=2048;modelTexture.height=Math.round(2048*SVG_PRINT_H/SVG_PRINT_W);
    const modelTextureCtx=modelTexture.getContext('2d',{alpha:false});
    let viewer=null,viewerBusy=false,modelTimer=null,previewVisible=false,previewObserver=null,expanded=false,priorFocus=null,priorOverflow='';

    function notify(message, type='info') {
      status.dataset.rawMessage=message;
      status.textContent = translateStatusRM(language,message);
      status.dataset.kind=type;
    }
    let language='de';
    const languageText=(key)=>LANG_TEXT_RM[language][key] ?? LANG_TEXT_RM.de[key] ?? key;
    const modelMessage=(key,detail='')=>{
      const node=$(root,'model-message');if(!node)return;
      node.dataset.rmMessageKey=key;node.dataset.rmMessageDetail=detail;
      node.textContent=key==='model_failure_prefix'
        ?languageText(key)+detail+languageText('model_failure_suffix')
        :languageText(key);
    };
    function setLanguage(next){
      language=next==='en'?'en':'de';
      root.lang=language;
      root.querySelectorAll('[data-rm-i18n]').forEach(node=>{
        const translated=languageText(node.dataset.rmI18n);
        if(translated!==undefined)node.textContent=translated;
      });
      root.querySelectorAll('[data-rm-aria]').forEach(node=>{
        node.setAttribute('aria-label',languageText(node.dataset.rmAria));
      });
      root.querySelectorAll('[data-rm-placeholder]').forEach(node=>{
        node.setAttribute('placeholder',languageText(node.dataset.rmPlaceholder));
      });
      root.querySelectorAll('[data-rm-lang]').forEach(button=>{
        const active=button.dataset.rmLang===language;
        button.classList.toggle('is-active',active);
        button.setAttribute('aria-pressed',String(active));
      });
      const model=$(root,'model-message');
      if(model?.dataset.rmMessageKey)modelMessage(model.dataset.rmMessageKey,model.dataset.rmMessageDetail||'');
      if(status?.dataset.rawMessage)status.textContent=translateStatusRM(language,status.dataset.rawMessage);
      if(addButton) addButton.textContent=languageText(state.busy?'files_preparing':'cart_button');
      if(expandButton){
        expandButton.textContent=(expanded?'✕ ':'⤢ ')+languageText(expanded?'close':'expand');
        expandButton.setAttribute('aria-label',languageText(expanded?'collapse_aria':'expand_aria'));
      }
      updateFields();renderLayers();
      try{window.localStorage.setItem('rm2d-language',language)}catch(e){}
    }
    root.querySelectorAll('[data-rm-lang]').forEach(button=>
      button.addEventListener('click',()=>setLanguage(button.dataset.rmLang))
    );
    function record() {
      const snap=JSON.stringify({base:state.base,items:serializeObjects(state.items)});
      if (state.history[state.historyAt]===snap) return;
      state.history=state.history.slice(0,state.historyAt+1);
      state.history.push(snap);
      if(state.history.length>22) state.history.shift();
      state.historyAt=state.history.length-1;
      updateUndoButtons();
    }
    function restore(idx) {
      if(idx<0||idx>=state.history.length)return;
      state.historyAt=idx;
      const data=JSON.parse(state.history[idx]);
      state.base=data.base;
      state.items=data.items.map(it=>({...it}));
      state.selected=null;
      state.items.forEach(loadImage);
      updateFields();render();updateUndoButtons();
    }
    function updateUndoButtons(){
      const u=$(root,'undo'),r=$(root,'redo');
      if(u)u.disabled=state.historyAt<=0;
      if(r)r.disabled=state.historyAt>=state.history.length-1;
    }
    function loadImage(o) {
      if(o.type!=='image' || !safeImageSource(o.src))return;
      const image=new Image();o.loading=true;
      image.onload=()=>{o.img=image;o.loading=false;render();};
      image.onerror=()=>{o.loading=false;notify('Ein Bild konnte nicht geladen werden.','error');};
      image.src=o.src;
    }
    function paintItems(ctx,scale=1) {
      state.items.forEach(o=>{
        ctx.save();ctx.translate(o.x,o.y);ctx.rotate(o.angle||0);
        if(o.type==='image') {
          if(o.img && o.img.complete) ctx.drawImage(o.img,-o.w/2,-o.h/2,o.w,o.h);
        } else if(o.type==='text') {
          const fontsize=num(o.fontSize,58), sca=num(o.scale,1);
          ctx.scale(sca,sca);
          ctx.fillStyle=o.color||'#111827';
          ctx.font=`900 ${fontsize}px "${o.font||'Arial'}"`;
          ctx.textAlign='center';ctx.textBaseline='middle';
          const lines=(o.text||'DEIN TEXT').split('\n').slice(0,3);
          lines.forEach((line,i)=>ctx.fillText(line,0,(i-(lines.length-1)/2)*fontsize*1.12));
        }
        ctx.restore();
      });
    }
    function artOn(ctx) {
      ctx.save();clipPrintZone(ctx);paintItems(ctx);ctx.restore();
    }
    function drawSurface(ctx) {
      ctx.save();
      ctx.shadowColor='rgba(17,24,39,.18)';ctx.shadowBlur=20;ctx.shadowOffsetY=9;
      withinPrintZone(ctx,(c,p)=>{c.fillStyle=state.base;c.fill(p);});
      ctx.restore();
      ctx.save();clipPrintZone(ctx);
      const gradient=ctx.createLinearGradient(0,PRINT_ZONE.y,0,PRINT_ZONE.y+PRINT_ZONE.h);
      gradient.addColorStop(0,'rgba(0,0,0,.09)');gradient.addColorStop(.2,'rgba(255,255,255,.22)');
      gradient.addColorStop(.7,'rgba(0,0,0,0)');gradient.addColorStop(1,'rgba(0,0,0,.14)');
      ctx.fillStyle=gradient;ctx.fillRect(PRINT_ZONE.x,PRINT_ZONE.y,PRINT_ZONE.w,PRINT_ZONE.h);
      if(state.guide){ctx.globalAlpha=.27;ctx.drawImage(state.guide,PRINT_ZONE.x,PRINT_ZONE.y,PRINT_ZONE.w,PRINT_ZONE.h);ctx.globalAlpha=1;}
      ctx.restore();
      artOn(ctx);
      withinPrintZone(ctx,(c,p)=>{c.strokeStyle='rgba(34,57,81,.48)';c.lineWidth=.8;c.stroke(p);});
    }
    function drawSelection(ctx) {
      const o=state.items.find(it=>it.id===state.selected);
      if(!o)return;
      ctx.save();ctx.translate(o.x,o.y);ctx.rotate(o.angle||0);
      ctx.strokeStyle='#1F76FA';ctx.lineWidth=2;ctx.setLineDash([7,5]);
      ctx.strokeRect(-o.w/2,-o.h/2,o.w,o.h);ctx.setLineDash([]);
      ctx.beginPath();ctx.moveTo(0,-o.h/2);ctx.lineTo(0,-o.h/2-34);ctx.stroke();
      [-1,1].forEach(sx=>[-1,1].forEach(sy=>{
        ctx.fillStyle='#fff';ctx.strokeStyle='#1F76FA';ctx.lineWidth=3;
        roundRect(ctx,sx*o.w/2-7,sy*o.h/2-7,14,14,4);ctx.fill();ctx.stroke();
      }));
      ctx.fillStyle='#1F76FA';ctx.beginPath();ctx.arc(0,-o.h/2-34,9,0,Math.PI*2);ctx.fill();
      ctx.restore();
    }
    function renderEditor() {
      edit.clearRect(0,0,WIDTH,HEIGHT);
      edit.fillStyle='#F2F5FA';edit.fillRect(0,0,WIDTH,HEIGHT);
      edit.strokeStyle='rgba(74,102,128,.065)';edit.lineWidth=1;
      for(let x=0;x<=WIDTH;x+=30){edit.beginPath();edit.moveTo(x,0);edit.lineTo(x,HEIGHT);edit.stroke();}
      for(let y=0;y<=HEIGHT;y+=30){edit.beginPath();edit.moveTo(0,y);edit.lineTo(WIDTH,y);edit.stroke();}
      drawSurface(edit);drawSelection(edit);
    }
    function renderLayers(){
      layers.replaceChildren();
      const rev=[...state.items].reverse();
      if(!rev.length){const p=document.createElement('p');p.className='rm2d-empty';p.textContent=languageText('empty_layers');layers.append(p);return;}
      rev.forEach(o=>{
        const b=document.createElement('button');b.type='button';b.className='rm2d-layer'+(o.id===state.selected?' is-active':'');
        const ico=document.createElement('span');ico.textContent=o.type==='text'?'T':'▧';ico.className='rm2d-layer-ico';
        const label=document.createElement('span');label.textContent=o.type==='text'?(o.text||'Text').slice(0,27):languageText('own_image');
        b.append(ico,label);b.addEventListener('click',()=>{state.selected=o.id;updateFields();render();});layers.append(b);
      });
    }
    function paintModelTexture(){
      // Background colour physically belongs to Plane.001, the print PNG remains transparent.
      const c=modelTextureCtx;
      c.setTransform(1,0,0,1,0,0);
      c.fillStyle=state.base;c.fillRect(0,0,modelTexture.width,modelTexture.height);
      c.setTransform(modelTexture.width/PRINT_ZONE.w,0,0,modelTexture.height/PRINT_ZONE.h,
        -PRINT_ZONE.x*modelTexture.width/PRINT_ZONE.w,-PRINT_ZONE.y*modelTexture.height/PRINT_ZONE.h);
      artOn(c);c.setTransform(1,0,0,1,0,0);
    }
    function refreshModel(){
      // One GPU view; update texture only when visible and after a short debounce.
      if(!viewer || !previewVisible)return;
      if(modelTimer)clearTimeout(modelTimer);
      modelTimer=setTimeout(()=>{
        modelTimer=null;
        if(!viewer || !previewVisible)return;
        paintModelTexture();viewer.refresh();
      },160);
    }
    async function openModel(){
      if(viewerBusy || !previewVisible)return;
      if(viewer){refreshModel();return;}
      viewerBusy=true;
      const modelUrl=root.dataset.modelUrl;
      const canvas=$(root,'model-canvas'),container=$(root,'model-container');
      const message=$(root,'model-message');
      message.hidden=false;modelMessage('model_loading');
      if(!window.RM3DViewer||!modelUrl||!canvas||!container){
        viewerBusy=false;modelMessage('model_unavailable');
        return;
      }
      try{
        paintModelTexture();container.hidden=false;
        viewer=await window.RM3DViewer.create(canvas,modelUrl,modelTexture);
        message.hidden=true;
        if(previewVisible)viewer.refresh();
      }catch(e){
        container.hidden=true;
        modelMessage('model_failure_prefix',e.message);
        notify('3D-Vorschau konnte nicht geladen werden.','error');
      }finally{viewerBusy=false;}
    }
    const modelPanel=$(root,'model-panel'),expandButton=$(root,'model-expand'),backdrop=$(root,'model-backdrop');
    function toggleExpand(force){
      const next=typeof force==='boolean'?force:!expanded;
      if(next===expanded)return;
      expanded=next;
      modelPanel.classList.toggle('is-expanded',expanded);
      backdrop.hidden=!expanded;
      expandButton.setAttribute('aria-expanded',String(expanded));
      expandButton.textContent=(expanded?'✕ ':'⤢ ')+languageText(expanded?'close':'expand');
      expandButton.setAttribute('aria-label',languageText(expanded?'collapse_aria':'expand_aria'));
      modelPanel.setAttribute('role',expanded?'dialog':'region');
      if(expanded)modelPanel.setAttribute('aria-modal','true');else modelPanel.removeAttribute('aria-modal');
      if(expanded){
        priorFocus=document.activeElement;
        priorOverflow=document.body.style.overflow;
        document.body.style.overflow='hidden';
        previewVisible=true;
        expandButton.focus();
        openModel();
      }else{
        document.body.style.overflow=priorOverflow;
        priorFocus?.focus?.();
      }
      // ResizeObserver in the WebGL viewer schedules a new frame after layout changes.
      if(viewer)requestAnimationFrame(()=>{if(viewer){paintModelTexture();viewer.refresh();}});
    }
    expandButton.addEventListener('click',()=>toggleExpand());
    backdrop.addEventListener('click',()=>toggleExpand(false));
    root.addEventListener('keydown',e=>{
      if(!expanded)return;
      if(e.key==='Escape'){e.preventDefault();toggleExpand(false);}
      if(e.key==='Tab'){
        // Keep keyboard focus within the expanded viewer.
        const focusables=[expandButton,$(root,'model-canvas')].filter(Boolean);
        const i=focusables.indexOf(document.activeElement);
        if(focusables.length && (i===-1 || (e.shiftKey&&i===0) || (!e.shiftKey&&i===focusables.length-1))){
          e.preventDefault();(e.shiftKey?focusables[focusables.length-1]:focusables[0]).focus();
        }
      }
    });
    if('IntersectionObserver' in window){
      previewObserver=new IntersectionObserver(entries=>{
        previewVisible=expanded||entries.some(entry=>entry.isIntersecting);
        if(previewVisible)openModel();
        else if(modelTimer){clearTimeout(modelTimer);modelTimer=null;}
      },{rootMargin:'150px 0px'});
      previewObserver.observe(modelPanel);
    }else{previewVisible=true;openModel();}
    function render() {renderEditor();renderLayers();refreshModel();}
    function updateFields(){
      const obj=state.items.find(it=>it.id===state.selected);
      if(obj && obj.type==='text'){
        textField.value=obj.text;fontField.value=obj.font||'Arial';fontSizeField.value=obj.fontSize||58;
        colorField.value=obj.color||'#111827';
      }
      baseField.value=state.base;
      root.querySelectorAll('[data-base]').forEach(b=>b.classList.toggle('is-selected',b.dataset.base.toUpperCase()===state.base.toUpperCase()));
      const detail=$(root,'selected-name');detail.textContent=obj?(obj.type==='text'?languageText('selected_text'):languageText('selected_image')):languageText('selected_none');
      const imageSelected=Boolean(obj&&obj.type==='image');
      if(bgTools)bgTools.hidden=!imageSelected;
      if(bgRemove)bgRemove.disabled=!imageSelected||bgBusy;
      if(bgRestore){bgRestore.hidden=!imageSelected||!obj.originalSrc||obj.src===obj.originalSrc;bgRestore.disabled=bgBusy;}
    }
    function selectNew(o){state.items.push(o);state.selected=o.id;record();updateFields();render();}
    function setTextSize(o){const m=textMetrics(o);o.w=m.w;o.h=m.h;}
    function addText(){
      const val=textField.value.trim().slice(0,150)||'DEIN TEXT';
      const o={id:id(),type:'text',text:val,x:WIDTH/2,y:HEIGHT/2,angle:0,
        color:state.base==='#111111'?'#FFFFFF':'#111827',autoTextColor:true,font:FONTS.includes(fontField.value)?fontField.value:'Arial',
        fontSize:clamp(num(fontSizeField.value,58),18,110),scale:1};
      setTextSize(o);selectNew(o);notify('Text hinzugefügt. Zum Verschieben einfach ziehen.','success');
    }
    function selectedText(){return state.items.find(it=>it.id===state.selected && it.type==='text');}
    function editText(){const o=selectedText();if(!o)return;
      o.text=textField.value.slice(0,150);o.font=FONTS.includes(fontField.value)?fontField.value:'Arial';
      o.fontSize=clamp(num(fontSizeField.value,58),18,110);o.color=colorField.value;
      setTextSize(o);render();
    }
    function getPoint(e){const b=editCanvas.getBoundingClientRect();
      return{x:(e.clientX-b.left)/b.width*WIDTH,y:(e.clientY-b.top)/b.height*HEIGHT};}
    function hitHandle(p,o){
      if(!o)return null;
      const rp=transformed(o,0,-o.h/2-34);
      if(Math.hypot(p.x-rp.x,p.y-rp.y)<20)return 'rotate';
      for(const a of [-1,1])for(const b of [-1,1]){
        const c=transformed(o,a*o.w/2,b*o.h/2);
        if(Math.hypot(p.x-c.x,p.y-c.y)<20)return 'scale';
      }
      return null;
    }
    function down(e){if(e.button!==0 && e.pointerType!=='touch')return;
      const p=getPoint(e), current=state.items.find(it=>it.id===state.selected);
      let which=hitHandle(p,current), object=current;
      if(!which){object=[...state.items].reverse().find(o=>pointInObject(p,o));which=object?'move':null;}
      state.selected=object?object.id:null;
      if(which&&object){
        state.gesture={type:which,x:p.x,y:p.y,original:{...object},
          length:Math.max(1,Math.hypot(p.x-object.x,p.y-object.y)),
          angle:Math.atan2(p.y-object.y,p.x-object.x)};
        editCanvas.setPointerCapture(e.pointerId);
      }
      updateFields();render();
    }
    function move(e){const g=state.gesture;if(!g)return;
      const p=getPoint(e),o=state.items.find(it=>it.id===state.selected);if(!o)return;
      if(g.type==='move'){
        o.x=clamp(g.original.x+p.x-g.x,-WIDTH/2,WIDTH*1.5);
        o.y=clamp(g.original.y+p.y-g.y,-HEIGHT/2,HEIGHT*1.5);
      } else if(g.type==='rotate') {
        o.angle=g.original.angle+Math.atan2(p.y-o.y,p.x-o.x)-g.angle;
      } else if(g.type==='scale') {
        const scale=clamp(Math.hypot(p.x-o.x,p.y-o.y)/g.length,.12,8);
        if(o.type==='text'){
          o.scale=clamp(g.original.scale*scale,.15,7);setTextSize(o);
        }else{o.w=clamp(g.original.w*scale,14,3000);o.h=clamp(g.original.h*scale,14,3000);}
      }
      render();
    }
    function up(){if(!state.gesture)return;state.gesture=null;record();render();}
    function act(name){const i=state.items.findIndex(o=>o.id===state.selected);
      switch(name){
        case 'add-text': addText();return;
        case 'undo':restore(state.historyAt-1);return;
        case 'redo':restore(state.historyAt+1);return;
        case 'remove':if(i<0)return;state.items.splice(i,1);state.selected=null;break;
        case 'front':if(i<0||i===state.items.length-1)return;state.items.splice(i+1,0,state.items.splice(i,1)[0]);break;
        case 'back':if(i<1)return;state.items.splice(i-1,0,state.items.splice(i,1)[0]);break;
        case 'center':if(i<0)return;state.items[i].x=WIDTH/2;state.items[i].y=HEIGHT/2;break;
        case 'export-png': downloadPNG();return;
        case 'export-json': downloadJSON();return;
        case 'import-json':$(root,'import-file').click();return;
        case 'reset':if(!window.confirm(languageText('reset_confirm')))return;state.items=[];state.selected=null;break;
        default:return;
      }
      record();updateFields();render();
    }
    function project(){return {format:'royalmouthguard-2d',version:1,editorWidth:WIDTH,editorHeight:HEIGHT,
      exportedAt:new Date().toISOString(),baseColor:state.base,baseColorName:state.base==='#111111'?'Schwarz':'Weiß',interiorColor:'#927748',interiorFinish:'Metallic',objects:serializeObjects(state.items),
      printMask:'rm-druckflaeche-original.svg',maskViewBox:[0,0,SVG_PRINT_W,SVG_PRINT_H],
      notice:'Plane.001 = wählbare Basis Schwarz/Weiß; Plane.002 = fixes Metallic-Gold #927748. Produktions-PNG enthält die Grundfarbe der Mundschutzform (schwarz/weiß) mit Design. Außenbereich transparent. UV-Ausrichtung und mm weiterhin prüfen.'};}
    function productionCanvas(){
      // Cricut cutout PNG: outer canvas transparent, inside actual mouthguard contour opaque.
      // Print millimeter dimensions must still be calibrated in Cricut Design Space.
      const outW=3600,outH=Math.round(outW*SVG_PRINT_H/SVG_PRINT_W);
      const c=document.createElement('canvas');c.width=outW;c.height=outH;
      const cc=c.getContext('2d');
      const sx=outW/PRINT_ZONE.w, sy=outH/PRINT_ZONE.h;
      cc.setTransform(sx,0,0,sy,-PRINT_ZONE.x*sx,-PRINT_ZONE.y*sy);
      cc.save();
      clipPrintZone(cc);
      cc.fillStyle=state.base;
      cc.fillRect(0,0,WIDTH,HEIGHT);
      paintItems(cc);
      cc.restore();
      return c;
    }
    const blobFrom=(canvas)=>new Promise((resolve,reject)=>canvas.toBlob(blob=>blob?resolve(blob):reject(new Error('PNG konnte nicht erstellt werden.')),'image/png'));
    function saveBlob(blob,filename){const url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download=filename;
      document.body.append(a);a.click();a.remove();window.setTimeout(()=>URL.revokeObjectURL(url),1200);}
    async function downloadPNG(){try{saveBlob(await blobFrom(productionCanvas()),'royalmouthguard-cricut-produktionsdatei-3600px.png');notify('Cricut-Produktions-PNG mit Mundschutzfarbe gespeichert.','success');}catch(e){notify(e.message,'error');}}
    function downloadJSON(){saveBlob(new Blob([JSON.stringify(project(),null,2)],{type:'application/json'}),'royalmouthguard-projekt.json');notify('Editierbare Projektdatei gespeichert.','success');}

    async function removeBackgroundFromSelected(){
      const obj=state.items.find(o=>o.id===state.selected&&o.type==='image');
      if(!obj||!obj.img||!obj.img.complete||obj.img.naturalWidth===0){notify('Bitte zuerst ein Bild auswählen.','error');return;}
      if(bgBusy)return;
      bgBusy=true;updateFields();notify('Bild wird freigestellt …','info');
      // Allow the progress text to paint before doing CPU-bound work.
      await new Promise(resolve=>setTimeout(resolve,35));
      try{
        const source=obj.originalSrc||obj.src;
        const image=await new Promise((resolve,reject)=>{
          const img=new Image();
          img.onload=()=>resolve(img);img.onerror=reject;img.src=source;
        });
        const result=removeConnectedBackgroundRM(image,bgTolerance?.value);
        if(result.alreadyTransparent){notify('Das Bild ist bereits transparent.','info');return;}
        if(result.ambiguous){notify('Hintergrund konnte nicht eindeutig erkannt werden. Verwende ein Bild mit möglichst einfarbigem Hintergrund.','error');return;}
        if(result.tooLarge){notify('Das Bild ist zu groß für die Bearbeitung auf diesem Gerät.','error');return;}
        if(!state.items.includes(obj))return; // the element was deleted while processing
        const replacement=await new Promise((resolve,reject)=>{
          const img=new Image();img.onload=()=>resolve(img);img.onerror=reject;img.src=result.src;
        });
        obj.originalSrc=source;
        obj.src=result.src;
        obj.img=replacement;
        obj.loading=false;
        record();updateFields();render();
        notify('Hintergrund entfernt. Das Original bleibt erhalten.','success');
      }catch(err){
        notify('Die Bildfreistellung ist fehlgeschlagen. Das Original bleibt unverändert.','error');
      }finally{bgBusy=false;updateFields();}
    }
    function restoreBackgroundOfSelected(){
      const obj=state.items.find(o=>o.id===state.selected&&o.type==='image');
      if(!obj?.originalSrc||bgBusy)return;
      obj.src=obj.originalSrc;
      obj.img=null;
      loadImage(obj);
      record();updateFields();render();
      notify('Originalbild wiederhergestellt.','success');
    }
    if(bgRemove)bgRemove.addEventListener('click',removeBackgroundFromSelected);
    if(bgRestore)bgRestore.addEventListener('click',restoreBackgroundOfSelected);
    function imageFile(file){
      if(!file)return;
      if(!['image/png','image/jpeg','image/webp'].includes(file.type)) {notify('Bitte PNG, JPG oder WebP hochladen.','error');return;}
      if(file.size>MAX_IMAGE_BYTES){notify('Bitte Bilder bis 4 MB auswählen.','error');return;}
      if(state.items.filter(o=>o.type==='image').length>=MAX_IMAGES){notify('Maximal sechs eigene Bilder pro Design.','error');return;}
      const assetTotal=state.items.filter(o=>o.type==='image').reduce((sum,o)=>sum+Math.ceil((o.src||'').length*0.75),0);
      if(assetTotal+file.size>9*1024*1024){notify('Bilder zusammen dürfen maximal 9 MB groß sein.','error');return;}
      const reader=new FileReader();reader.onerror=()=>notify('Bild konnte nicht gelesen werden.','error');
      reader.onload=()=>{
        const src=String(reader.result||'');if(!safeImageSource(src)){notify('Bildformat nicht unterstützt.','error');return;}
        const image=new Image();image.onload=()=>{
          const maxWidth=330,maxHeight=160,s=Math.min(maxWidth/image.naturalWidth,maxHeight/image.naturalHeight,1);
          const o={id:id(),type:'image',src,x:WIDTH/2,y:HEIGHT/2,angle:0,
            w:Math.max(25,image.naturalWidth*s),h:Math.max(25,image.naturalHeight*s),img:image};
          selectNew(o);notify('Bild hinzugefügt. An den Eckpunkten skalieren.','success');
        };image.onerror=()=>notify('Bild ist beschädigt oder nicht lesbar.','error');image.src=src;
      };reader.readAsDataURL(file);
    }
    async function importJSON(file){if(!file)return;
      if(file.size>16*1024*1024){notify('Projektdatei zu groß (maximal 16 MB).','error');return;}
      try{
        const p=JSON.parse(await file.text());
        if(p.format!=='royalmouthguard-2d'||p.version!==1||!Array.isArray(p.objects)||p.objects.length>50)
          throw new Error('Ungültige Projektdatei.');
        const cleaned=[];
        for(const raw of p.objects){
          if(raw.type!=='text' && raw.type!=='image')continue;
          if(raw.type==='image'&&!safeImageSource(raw.src))continue;
          const o={id:id(),type:raw.type,x:clamp(num(raw.x,480),-500,1500),y:clamp(num(raw.y,210),-500,900),
            angle:clamp(num(raw.angle,0),-100,100)};
          if(raw.type==='text'){
            Object.assign(o,{text:String(raw.text||'Text').slice(0,150),color:COLORS.includes(raw.color)||/^#[0-9a-f]{6}$/i.test(raw.color||'')?raw.color:'#111827',
              font:FONTS.includes(raw.font)?raw.font:'Arial',fontSize:clamp(num(raw.fontSize,58),18,110),scale:clamp(num(raw.scale,1),.15,7),autoTextColor:raw.autoTextColor===true});
            setTextSize(o);
          }else{Object.assign(o,{src:raw.src,originalSrc:safeImageSource(raw.originalSrc)?raw.originalSrc:undefined,w:clamp(num(raw.w,100),14,3000),h:clamp(num(raw.h,80),14,3000)});}
          cleaned.push(o);
        }
        state.items=cleaned;state.base=BASES.includes(String(p.baseColor||'').toUpperCase())?String(p.baseColor).toUpperCase():'#FFFFFF';
        state.selected=null;state.items.forEach(loadImage);record();updateFields();render();notify('Projekt erfolgreich geladen.','success');
      }catch(err){notify('Projekt konnte nicht importiert werden: '+err.message,'error');}
    }
    async function submitShopify(){
      if(bgBusy){notify('Bitte warten, bis das Bild bearbeitet wurde.','error');return;}
      if(state.busy)return;
      if(!state.items.length){notify('Bitte füge zuerst Text oder ein Bild hinzu.','error');return;}
      if(state.items.some(o=>o.type==='image' && (!o.img || !o.img.complete || o.img.naturalWidth===0))){
        notify('Ein Bild lädt noch oder konnte nicht geladen werden.','error');return;
      }
      const form=root.querySelector('.rm2d-order-form');
      if(root.dataset.mode!=='shopify'||!form){
        notify('Demo-Modus: Hier kannst du die Dateien exportieren. Im Shopify-Theme funktioniert danach der echte Warenkorb.','info');
        return;
      }
      const variant=form.querySelector('select[name="id"]');
      if(!variant||!variant.value){notify('Bitte eine verfügbare Produktvariante auswählen.','error');return;}
      state.busy=true;addButton.disabled=true;addButton.textContent=languageText('files_preparing');
      try{
        const png=await blobFrom(productionCanvas());
        const json=new Blob([JSON.stringify(project())],{type:'application/json'});
        // Native Shopify product form upload via multipart/form-data, not Ajax cart drawer.
        const dt1=new DataTransfer();dt1.items.add(new File([png],'Royalmouthguard-Cricut-Produktionsdatei.png',{type:'image/png'}));
        const dt2=new DataTransfer();dt2.items.add(new File([json],'Royalmouthguard-Design.json',{type:'application/json'}));
        $(root,'shopify-png').files=dt1.files;
        $(root,'shopify-json').files=dt2.files;
        $(root,'design-id').value='RM-'+Date.now()+'-'+id();
        const baseOrder=$(root,'order-base-color');
        if(baseOrder)baseOrder.value=state.base==='#111111'?'Schwarz':'Weiß';
        if(!$(root,'shopify-png').files.length) throw new Error('PNG konnte nicht an den Warenkorb übertragen werden.');
        notify('Dateien vorbereitet. Weiterleitung zum Warenkorb …','success');
        // Bypass some themes' AJAX submit interception; let Shopify receive actual file input data.
        HTMLFormElement.prototype.submit.call(form);
      }catch(err){notify('Bestellung nicht gestartet: '+err.message,'error');state.busy=false;addButton.disabled=false;addButton.textContent=languageText('cart_button');}
    }
    root.querySelectorAll('[data-action]').forEach(button=>button.addEventListener('click',()=>act(button.dataset.action)));
    root.querySelectorAll('[data-base]').forEach(button=>button.addEventListener('click',()=>{
      if(!BASES.includes(button.dataset.base.toUpperCase()))return;
      state.base=button.dataset.base.toUpperCase();
      const newTextColor=state.base==='#111111'?'#FFFFFF':'#111827';
      state.items.forEach(o=>{if(o.type==='text'&&o.autoTextColor)o.color=newTextColor;});
      if(!selectedText())colorField.value=newTextColor;
      record();updateFields();render();
    }));
    // Colour selection is deliberately limited to validated physical stock: black and white.
    textField.addEventListener('input',editText);fontField.addEventListener('change',()=>{editText();record();});
    fontSizeField.addEventListener('input',editText);fontSizeField.addEventListener('change',record);
    colorField.addEventListener('input',()=>{const o=selectedText();if(o)o.autoTextColor=false;editText();});colorField.addEventListener('change',record);
    textField.addEventListener('change',record);
    imageInput.addEventListener('change',()=>{imageFile(imageInput.files[0]);imageInput.value='';});
    $(root,'import-file').addEventListener('change',e=>{importJSON(e.target.files[0]);e.target.value='';});
    editCanvas.addEventListener('pointerdown',down);editCanvas.addEventListener('pointermove',move);
    editCanvas.addEventListener('pointerup',up);editCanvas.addEventListener('pointercancel',up);
    editCanvas.addEventListener('lostpointercapture',up);
    editCanvas.addEventListener('keydown',e=>{
      const o=state.items.find(it=>it.id===state.selected);if(!o)return;
      const arrows={ArrowLeft:[-1,0],ArrowRight:[1,0],ArrowUp:[0,-1],ArrowDown:[0,1]};
      if(e.key==='Delete'||e.key==='Backspace'){e.preventDefault();act('remove');}
      else if(arrows[e.key]){e.preventDefault();o.x+=arrows[e.key][0]*(e.shiftKey?10:2);o.y+=arrows[e.key][1]*(e.shiftKey?10:2);record();render();}
    });
    if(addButton)addButton.addEventListener('click',submitShopify);
    // Free GPU resources if this Shopify Theme Editor section is removed.
    document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(root)){if(expanded)toggleExpand(false);previewObserver?.disconnect();if(modelTimer)clearTimeout(modelTimer);viewer?.dispose();viewer=null;}});
    const guideUrl=root.dataset.guideUrl;
    if(guideUrl){const g=new Image();g.crossOrigin='anonymous';g.onload=()=>{state.guide=g;render();};g.onerror=()=>notify('UV-Hilfsbild konnte nicht angezeigt werden – Standardvorlage aktiv.','info');g.src=guideUrl;}
    let savedLang='de';
    try{savedLang=window.localStorage.getItem('rm2d-language')||'de'}catch(e){}
    setLanguage(savedLang);
    record();updateFields();render();
  }
  function boot(){document.querySelectorAll('.rm2d[data-rm2d]').forEach(initialize);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
